import { sizes } from "@/shared/styles";
import styled from "styled-components";

export const PageWrapStyled = styled.div`
  height: 100%;
  width: 100%;
`;

export const PageHeaderWrap = styled.div`
  border-bottom: solid 1px rgba(0, 0, 0, 0.2);
`;

export const PageContent = styled.div`
  width: 100%;
  height: 100%;
  max-width: 100%;

  overflow-y: hidden;
  overflow-x: auto;
  position: relative;
`;

export const PageHeaderRoot = styled.div`
  .pg-header-footer {
    padding: ${sizes.appPadding.middle}px ${sizes.appPadding.middle}px;
  }
`;

export const PageHeaderStyled = styled.div`
  display: flex;
  padding: ${sizes.appPadding.middle}px;
  padding-bottom: 0px;
  justify-content: space-between;

  .bp4-heading {
    margin-bottom: ${sizes.appPadding.small}px;
  }
`;
